import * as React from "react";
import { Button, Form, Header, GridRow, Segment, Select } from "semantic-ui-react";

import configs from "../helpers/config";
import "../helpers/styles.css";
import { showMessage } from '../helpers/helper';

export default class PacientesRegistro extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleRegistro() {
        if (!this.state.celular) {
            showMessage("Informe um celular");
            return;
        }

        if (!this.state.nascimento) {
            showMessage("Informe uma data de nascimento");
            return;
        }

        if (!this.state.email) {
            showMessage("Informe um email");
            return;
        }

        if (!this.state.nome) {
            showMessage("Informe um nome");
            return;
        }

        if (!this.state.nomeMae) {
            showMessage("Informe o nome da mãe");
            return;
        }

        if (!this.state.cpf) {
            showMessage("Informe um cpf/documento");
            return;
        }

        if (!this.state.chaveAcesso) {
            showMessage("Informe a chave de acesso");
            return;
        }

        this.props.onRegistro({
            nome: this.state.nome,
            nomeMae: this.state.nomeMae,
            celular: this.state.celular,
            chaveAcesso: this.state.chaveAcesso,
            cpf: this.state.cpf,
            nascimento: this.state.nascimento,
            email: this.state.email,
        });
    }

    handleCelular = (e) => {
        let tel = e.target.value;

        tel = tel.replace(/\D/g, "");

        if (tel.length > 11) {
            tel = tel.substring(0, 11);
        }

        tel = tel.replace(/^(\d)/, "($1");
        tel = tel.replace(/(.{3})(\d)/, "$1) $2");
        if (tel.length === 10) {
            tel = tel.replace(/(.{1})$/, "-$1");
        } else if (tel.length === 11) {
            tel = tel.replace(/(.{2})$/, "-$1");
        } else if (tel.length === 12) {
            tel = tel.replace(/(.{3})$/, "-$1");
        } else if (tel.length === 13) {
            tel = tel.replace(/(.{4})$/, "-$1");
        } else if (tel.length > 13) {
            tel = tel.replace(/(.{4})$/, "-$1");
        }

        this.setState({ celular: tel });
    };

    handleNumeroConselho = (e) => {
        let numero = e.target.value.replace(/\D/g, "");
        this.setState({ numeroConselho: numero });
    };

    handleCpf = (e) => {
        const value = e.target.value;
        const cpf = value.replaceAll(/[^0-9]/g, "");
        this.setState({
            cpf,
        });
    };

    render() {
        return (
            <Segment className={this.props.className}>
                <Header as="h2">
                    <p className="headerLogin">Registro de Login para Paciente</p>
                </Header>

                <Form size="large">
                    <GridRow>
                        <Form.Input
                            fluid
                            icon="key"
                            iconPosition="left"
                            placeholder="Chave Acesso (Cabeçalho do talão)"
                            value={this.state.chaveAcesso}
                            onChange={(e) => this.setState({ chaveAcesso: e.target.value })}
                        />
                        <Form.Input
                            fluid
                            icon="pencil"
                            iconPosition="left"
                            placeholder="Nome (Completo e sem abreviações)"
                            value={this.state.nome}
                            onChange={(e) => this.setState({ nome: e.target.value })}
                        />
                        <Form.Input
                            fluid
                            icon="user"
                            iconPosition="left"
                            placeholder="Nome da Mãe (Completo e sem abreviações)"
                            value={this.state.nomeMae}
                            onChange={(e) => this.setState({ nomeMae: e.target.value })}
                        />
                        <Form.Input
                            fluid
                            type="date"
                            icon="calendar"
                            iconPosition="left"
                            placeholder="Nascimento"
                            value={this.state.nascimento}
                            onChange={(e) => this.setState({ nascimento: e.target.value })}
                        />
                        <Form.Input
                            fluid
                            icon="at"
                            iconPosition="left"
                            placeholder="Email"
                            value={this.state.email}
                            onChange={(e) => this.setState({ email: e.target.value })}
                        />
                        <Form.Input
                            fluid
                            icon="credit card outline"
                            iconPosition="left"
                            placeholder="CPF/Documento (Estrangeiros)"
                            value={this.state.cpf}
                            onChange={this.handleCpf}
                        />
                        <Form.Input
                            fluid
                            icon="phone"
                            iconPosition="left"
                            placeholder="Celular"
                            value={this.state.celular}
                            onChange={this.handleCelular}
                        />
                        <Button fluid size="large" onClick={() => this.handleRegistro()}>
                            Solicitar
                        </Button>
                    </GridRow>
                </Form>
            </Segment>
        );
    }
}
